import {
	Component,
	ComponentFactoryResolver,
	OnDestroy,
	OnInit,
} from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BroadcastService } from "../../../../shared/services/broadcast.service";
import { NRModalService } from "../../../../shared/modal/services/nrmodal.service";
import { SwalService } from "../../../../shared/services/swal.service";
import { UnitssService } from "../../../../services/unitss.service";
import { Subject } from "rxjs";
import {
	EventModel,
	EventSubscriptionType,
	EventType,
} from "../../../../shared/interfaces/event.model";
import { takeUntil } from "rxjs/operators";
import { DynamicHostModel } from "../../../../shared/modal/models/dynamic-host.model";
import { CustomersService } from "../../../../services/customers.service";
import { ControlService } from "../../../../services/control.service";

import * as ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { UsersService } from "../../../../services/users.service";
import { EditCreateCompanyClientsComponent } from "./edit-create-company-clients/edit-create-company-clients.component";
import { MediasService } from "../../../../services/medias.service";
import { MediaClientsService } from "../../../../services/media-clients.service";
import { CompanyClientService } from "../../../../services/company-clients.service";

interface DataTableColumn {
	title: string;
	field: string;
	type?: string;
	default?: any;
}

@Component({
	selector: "app-company-client",
	templateUrl: "./company-client.component.html",
	styleUrls: ["./company-client.component.scss"],
})
export class CompanyClientComponent implements OnInit {
	data: any = {};
	isLoading: boolean = false;

	showClientModal = false;
	selectedClient: number | null = null;

	public UsersSocket = null;

	dtConfig = {
		config: {
			base: this.companyclientService,
			is_alive: true,
			api: "datatable",
			rowsPerPage: 10,
			order: [[1, "desc"]],
			params: {
				key: "",
				client_id: null,
				company_client_id: null,
			},
			hasCustomProcessData: true,
			processValues: async (response) => {
				response.data.map((unit: any) => {
					unit.client_name =
						this.clientesMap.get(unit.client_id) ||
						"Cliente no asociado";

					return unit;
				});
				return response;
			},
		},
		columns: [],
		actions: [],
	};
	isAdmin: boolean = false;
	clientes: any = {};
	companias: any = {};
	clientesMedia: any = {};
	selectedClientId: number | null = null;
	selectedCompanieId: number | null = null;
	searchName: string = "";
	private atComponentDestroy = new Subject();
	private clientesMap = new Map<number, string>();
	private companiesMap = new Map<number, string>();

	paginationData: any = {
		current_page: 1,
		from: 1,
		last_page: 0,
		per_page: 0,
		to: 0,
		total: 0,
	};

	constructor(
		public modalRef: BsModalService,
		private componentFactoryResolver: ComponentFactoryResolver,
		private broadcast: BroadcastService,
		private nrModal: NRModalService,
		private swal: SwalService,
		private unitsService: UnitssService,
		private customersService: CustomersService,
		private controlservice: ControlService,
		private userService: UsersService,
		private mediaclientService: MediaClientsService,
		private companyclientService: CompanyClientService,
	) {}

	onClientChange(): void {
		if (this.selectedClientId) {
			this.dtConfig.config.params.client_id = this.selectedClientId;
		} else {
			delete this.dtConfig.config.params.client_id;
		}
		this.broadcast.reloadDataTable();
	}

	clearFilters(): void {
		delete this.dtConfig.config.params.client_id;
		this.selectedClientId = null;
		this.searchName = "";
		this.updateDataTable(1, {});
	}

	async ngOnInit(): Promise<void> {
		
		await this.controlservice.isAdmin().subscribe(async (res) => {
		
			this.isAdmin = res.is_admin;

			// ← Acciones condicionales según rol
			this.dtConfig.actions = this.isAdmin
				? [
						{
							display: "Editar",
							icon: "fa-pencil",
							event: "media-client.edit",
							conditionality: "true",
						},
						{
							display: "Eliminar",
							icon: "fa-trash",
							event: "media-client.delete",
							conditionality: "true",
						},
					]
				: [];

			this.UsersSocket = this.userService;

			// ← Columnas condicionales
			this.setupColumns();

			this.clientes = await this.customersService.getActives();
			this.clientes.forEach((cliente) => {
				this.clientesMap.set(cliente.id, cliente.name ?? cliente.name);
			});

			// ← Escuchar eventos
			this.broadcast
				.onEvent(EventSubscriptionType.TYPE, EventType.MODAL)
				.pipe(takeUntil(this.atComponentDestroy))
				.subscribe(async (event: EventModel) => {
					const props = await this.prepareProps(event);
					if (props) {
						this.nrModal.open(props);
					}
				});
		});
	}

	showUsersSocket(): void {}

	ngOnDestroy(): void {
		this.atComponentDestroy.next();
		this.atComponentDestroy.unsubscribe();
	}

	setupColumns(): void {
		const columns: DataTableColumn[] = [];
		if (this.isAdmin) {
			columns.push({ title: "ID", field: "id" });
		}

		columns.push(
			{ title: "Nombre", field: "name" },
			{ title: "Razon Social", field: "legal_name" },
			{ title: "Representante", field: "contact_name" },
			{ title: "Número Telefónico", field: "phone_number" },
			{ title: "Cliente", field: "client_name" },
		);

		columns.push({ title: "Correo Electrónico", field: "email" });

		this.dtConfig.columns = columns;
	}

	updateDataTable(page: number, options: any = {}): void {
		this.companyclientService
			.datatable(page, options)
			.subscribe((data: any) => {
				this.clientesMedia = data.data;
				delete data.data;
				delete data.links;
				this.paginationData = data;
			});
			this.broadcast.reloadDataTable();
	}

	async prepareProps(event: EventModel): Promise<any> {
		const props: DynamicHostModel = new DynamicHostModel();
		props.instantiated = false;
		event.data.item = event.data.item || {};

		props.modalModel = {
			component: null,
			componentFactoryResolver: this.componentFactoryResolver,
			data: event.data.item || {},
		};

		switch (event.name) {
			case "media-client.add":
				props.modalModel.component = EditCreateCompanyClientsComponent;
				props.modalModel.modalConfiguration = {
					title: "Agregar Compañia",
				};
				break;

			case "media-client.edit":
				props.modalModel.component = EditCreateCompanyClientsComponent;
				props.modalModel.modalConfiguration = {
					title: "Editar Compañia",
				};
				break;
			case "media-client.delete":
				this.delete(event.data);
				return false;
		}

		return props;
	}

	add(): void {
		this.broadcast.fire({
			name: "media-client.add",
			type: EventType.MODAL,
			data: {},
		});
	}

	delete(data): void {
		const swalParams = {
			title: "¿Estás seguro de querer eliminarlo?",
		};

		this.swal.warning(swalParams).then((result) => {
			if (result.value) {
				this.companyclientService
					.delete(data.item.id)
					.subscribe((resp: any) => {
						if (resp.message) {
							this.swal
								.success({
									title: "Compañía eliminado exitosamente",
								})
								.then(() => {
									this.modalRef.hide(0);
									this.broadcast.reloadDataTable();
								});
						} else {
							this.swal.error(
								"Ocurrió un error al intentar borrar la unidad",
							);
						}
					});
			}
		});
	}

}
